import { processResponse, processError } from '../auth';

const patchMe = (language) => {
  const url = new URL(process.env.GATSBY_BASE_URL + 'livquest/me/');

  const token = localStorage.getItem('questCode');
  return fetch(url, {
    method: 'PATCH',
    body: JSON.stringify({ language }),
    headers: { Authorization: `Quest ${token}`, 'Content-Type': 'application/json' },
  })
    .then((response) => {
      return processResponse(response);
    })
    .then((response) => {
      return { ...response };
    })
    .catch((err) => {
      processError(err, 'livquestPatchMe');
    });
};

export { patchMe };
